/**
 * Checks if the given date is a valid Date object.
 *
 * @param {any} date - The value to be checked.
 * @returns {boolean} - Returns true if the date is a valid Date object and not NaN, otherwise false.
 */
export const isValidDate = (date: any): boolean => {
    return date instanceof Date && !isNaN(date as any);
};

export const hasValuesForEachProperty = (obj) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined)) {
            return false;
        }
    }
    return true;
};
